<!--
  @description: 微信通知服务 - 基础配置页面
  @author: system
  @date: 2026-06-02
  @note: 包含公众号配置和消息模版管理两个Tab
-->
<template>
  <div class="base-config-container">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h2 class="page-title">
        <i class="el-icon-setting"></i>
        基础配置
      </h2>
      <p class="page-desc">公众号和消息模版的基础配置管理</p>
    </div> -->

    <!-- Tab 切换 -->
    <div class="tabs-wrapper">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" type="card" class="custom-tabs">
        <!-- 公众号配置 Tab -->
        <el-tab-pane label="公众号配置" name="account">
          <template slot="label">
            <span class="tab-label">
              <i class="el-icon-chat-dot-round"></i>
              公众号配置
            </span>
          </template>
          <account-config ref="accountConfig" />
        </el-tab-pane>

        <!-- 消息模版管理 Tab -->
        <el-tab-pane label="消息模版管理" name="template">
          <template slot="label">
            <span class="tab-label">
              <i class="el-icon-message"></i>
              消息模版管理
            </span>
          </template>
          <template-manage ref="templateManage" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
/**
 * @description 基础配置主页面
 * @component BaseConfig
 */
import AccountConfig from "./components/AccountConfig.vue";
import TemplateManage from "./components/TemplateManage.vue";

export default {
  name: "BaseConfig",
  components: {
    AccountConfig,
    TemplateManage
  },
  data() {
    return {
      // 当前激活的Tab页签
      activeTab: "account"
    };
  },
  created() {
    // 从路由参数读取激活的Tab（如果有）
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    }
  },
  methods: {
    /**
     * @description Tab切换事件
     * @param {Object} tab - 当前Tab对象
     */
    handleTabClick(tab) {
      // 更新路由参数，保留Tab状态
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: this.activeTab
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.base-config-container {
  // padding: 20px;
  // min-height: 100vh;
  // background: #f5f7fa;

  // 页面头部
  .page-header {
    margin-bottom: 24px;
    padding: 24px 30px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);

    .page-title {
      margin: 0 0 8px 0;
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      display: flex;
      align-items: center;
      gap: 12px;

      i {
        font-size: 32px;
      }
    }

    .page-desc {
      margin: 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.85);
    }
  }

  // Tab包装器
  .tabs-wrapper {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    padding: 20px;

    /deep/ .custom-tabs {
      .el-tabs__header {
        margin-bottom: 20px;
      }

      .el-tabs__nav {
        border: none;
      }

      .el-tabs__item {
        height: 50px;
        line-height: 50px;
        border: 1px solid #e4e7ed;
        border-radius: 8px 8px 0 0;
        margin-right: 8px;
        padding: 0 24px;
        font-size: 15px;
        transition: all 0.3s;

        &:hover {
          color: #165DFF;
        }

        &.is-active {
          background: #165DFF;
          color: #fff;
          border-color: transparent;
        }

        .tab-label {
          display: flex;
          align-items: center;
          gap: 8px;

          i {
            font-size: 18px;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .base-config-container {
    padding: 10px;

    .page-header {
      padding: 20px;

      .page-title {
        font-size: 22px;

        i {
          font-size: 26px;
        }
      }
    }

    .tabs-wrapper {
      padding: 15px;

      /deep/ .custom-tabs {
        .el-tabs__item {
          padding: 0 16px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
